import React, { useContext, useEffect, useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { RiForward30Line, RiReplay30Fill } from "react-icons/ri";
import { IoShareSocialOutline } from "react-icons/io5";
import { ApiContext } from "../context/ApiContext";

const AudioPlayer = () => {
  const { innerAudioRef, togglePlayPause, isPlayingOrNot, setIsPlayingOrNot, audioSrc,isPlayings,setIsPlayings,handleTimeUpdate,currentTime,setCurrentTime,duration, setDuration,isMetadataLoading, setIsMetadataLoading } = useContext(ApiContext);
  const [speed, setSpeed] = useState(1);
  // const [currentTime, setCurrentTime] = useState(0);
  // const [duration, setDuration] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
 

  useEffect(() => {
    if (audioSrc) {
      setCurrentTime(0);
      setDuration(0);
      setIsMetadataLoading(true);
    }
  }, [audioSrc]);

// useEffect(()=>{
//   console.log("ch1");
  
//   if (audioSrc) {
//     console.log("ch2",audioSrc);
    
//     setCurrentTime(0);
//     setDuration(0);
//     setIsMetadataLoading(true);
//   }
// })
 
// console.log(isMetadataLoading,"matadata ------------------- lo -----------------");



  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleSpeedChange = (newSpeed) => {
    innerAudioRef.current.playbackRate = newSpeed;
    setSpeed(newSpeed);
    setShowDropdown(false);
  };

  const handleSeek = (e) => {
    const newTime = (e.target.value * duration) / 100;
    innerAudioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  const handleShare = () => {
    // const url = window.location.origin + audioSrc;
    const url = window.location.origin;
    navigator.clipboard.writeText(url).then(() => {
      alert("URL copied, now you can share");
    }).catch((err) => {
      console.error("Failed to copy text: ", err);
    });
  };

  const handleSkip = (seconds) => {
    const newTime = Math.min(Math.max(innerAudioRef.current.currentTime + seconds, 0), duration);
    innerAudioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  };

  return (
    <div className="audio-player">
 
      {/* Play/Pause button */}
      <div className="flex justify-center mb-4">
        <button
          onClick={togglePlayPause}
          disabled={isMetadataLoading} // Disable button while metadata is loading
          className={`play-btn bg-blue-500 hover:bg-[#F9F871] text-white font-bold py-2 px-4 rounded-full`}
        >
          {isMetadataLoading ? (
    <div className="loader"></div> // Replace this with your spinner component or element
  ) : isPlayingOrNot ? (
    <Pause size={28} />
  ) : (
    <Play size={28} />
  )}
        </button>
      </div>

      {/* Playback speed and control buttons */}
      <div className="flex justify-around items-center" style={{ margin: "20px 0px" }}>
        <button
          style={{ color: "#D9EE15" }}
          onClick={() => setShowDropdown(!showDropdown)}
          className="text-white text-sm font-bold py-2 px-4 rounded"
        >
          {speed}x
        </button>

        {showDropdown && (
          <div
            style={{
              backgroundColor: "#d9ee1591",
              color: "white",
              padding: "5px",
              marginLeft: "-288px",
              marginBottom: "200px",
            }}
            className="absolute mt-2 rounded shadow-lg"
          >
            {[2, 1.75, 1.5, 1.25, 1, 0.75].map((option) => (
              <div key={option}>
                <button
                  onClick={() => handleSpeedChange(option)}
                  className="block w-full text-left px-4 py-2"
                  style={{
                    color: "#161414",
                    width: "80px",
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #161414",
                  }}
                >
                  <span>{option}x</span> <span className="text-xl font-bold">{option === speed && "✓"}</span>
                </button>
              </div>
            ))}
          </div>
        )}

        <button
          style={{ color: "#D9EE15" }}
          onClick={() => handleSkip(-30)}
          className="text-xl font-bold py-2 px-4 rounded"
        >
          <RiReplay30Fill />
        </button>

        <button
          style={{ color: "#D9EE15" }}
          onClick={() => handleSkip(30)}
          className="text-xl font-bold py-2 px-4 rounded"
        >
          <RiForward30Line />
        </button>

        <button
          style={{ color: "#D9EE15" }}
          onClick={() => handleShare()}
          className="text-xl font-bold py-2 px-4 rounded"
        >
          <IoShareSocialOutline />
        </button>
      </div>

      <hr className="My-audio-payer-hr" />

      {/* Range input for currentTime */}
      <div className="mb-4 my-range-input-of-audio-player">
        <input
          type="range"
          min="0"
          max="100"
          value={(currentTime / duration) * 100 || 0}
          onChange={handleSeek}
          className="seek-bar w-full"
          style={{
            backgroundImage: `linear-gradient(#d9ee15, #d9ee15)`,
            backgroundSize: `${(currentTime / duration) * 100}% 100%`,
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="flex justify-between text-white text-sm mt-1" style={{ width: "100%" }}>
          <span style={{ color: "#D9EE15" }}>{formatTime(currentTime)}</span>
          <span style={{ color: "#D9EE15" }}>{formatTime(duration)}</span>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;












































































































































































// import React, { useContext, useEffect, useRef, useState } from "react";
// import { Play, Pause, RotateCw, Share } from "lucide-react";
// // import "./AudioPlayer.css"; // Import the custom CSS
// import { RiForward30Line } from "react-icons/ri";
// import { RiReplay30Fill } from "react-icons/ri";
// import { IoShareSocialOutline } from "react-icons/io5";
// import { ApiContext } from "../context/ApiContext";
// import { Auuddiioo } from "./Layout/AllPagiesLayout";

// const AudioPlayer = ({ audioSrc }) => {
  
//   const [speed, setSpeed] = useState(1);

//   const [showDropdown, setShowDropdown] = useState(false);
//   const {togglePlayPause5,isPlayings,audiosRef,innerAudioRef,setIsPlaying,isPlaying,setAudioUrl,currentTime, setCurrentTime,duration} = useContext(ApiContext)
//   useEffect(()=>{
//     if(audioSrc){
//       setAudioUrl(audioSrc);
//     }
//   },[audioSrc])



//   useEffect(()=>{
//   if(isPlayings){
//     if (audiosRef.current) {
//             audiosRef.current.play().catch(error => console.error("Play error: ", error));
//             setIsPlaying(false)
//           }if(!isPlaying){
            
//             innerAudioRef.current.pause();
//           }
//   }else{
//     if (audiosRef.current) {
//       audiosRef.current.pause();
//     }  
//   }
//   },[isPlayings,isPlaying,audiosRef,innerAudioRef])




  
//   // useEffect(() => {
// //   if (isPlayings) {
// //     if (audiosRef.current) {
// //       audiosRef.current.play().catch(error => console.error("Play error: ", error));
// //     }
// //     if (innerAudioRef.current) {
// //       innerAudioRef.current.pause();
// //       // setIsPlaying(false)
// //     }
// //   } else {
// //     if (audiosRef.current) {
// //       audiosRef.current.pause();
// //     }
// //   }
// // }, [isPlayings, audiosRef, innerAudioRef]);



//   // const handleSpeedChange = () => {
//   //   const newSpeed = speed === 1 ? 0.75 : 1;
//   //   audiosRef.current.playbackRate = newSpeed;
//   //   setSpeed(newSpeed);
//   // };
//   const handleSpeedChange = (newSpeed) => {
//     audiosRef.current.playbackRate = newSpeed;
//     setSpeed(newSpeed);
//     setShowDropdown(false);
//   };

//   const speedOptions = [2, 1.75, 1.5, 1.25, 1, 0.75];


//   const handleSeek = (e) => {
//     const newTime = (e.target.value * duration) / 100;
//     audiosRef.current.currentTime = newTime;
//     setCurrentTime(newTime);
//   };
//   const handleShare = (e) =>{
//     const url = window.location.origin+audioSrc
//     navigator.clipboard.writeText(url).then(() => {
//       alert("URL copied now you can share")
//   }).catch(err => {
//       console.error('Failed to copy text: ', err);
//   });
    
//   }

//   const handleSkip = (seconds) => {
//     const newTime = Math.min(Math.max(audiosRef.current.currentTime + seconds, 0), duration);
//     audiosRef.current.currentTime = newTime;
//     setCurrentTime(newTime);
//   };

//   const formatTime = (time) => {
//     const minutes = Math.floor(time / 60);
//     const seconds = Math.floor(time % 60);
//     return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
//   };

//   return (
//     <div className="audio-player ">
//      {/* <Auuddiioo 
//      audiosRef={audiosRef}
//      audioUrl={audioSrc}
//      handleTimeUpdate={handleTimeUpdate}/> */}
      

//     <div className="flex justify-center mb-4">
//       <button
//         onClick={togglePlayPause5}
//         className="play-btn bg-blue-500 hover:bg-[#e6ff00] text-white font-bold py-2 px-4 rounded-full"
//       >
//         {isPlayings ? <Pause size={28} /> : <Play size={28} />}
//       </button>
//     </div>

//     <div className="flex justify-around items-center" style={{margin:"20px 0px"}}>
//     {/* <button style={{color:"#D9EE15"}} onClick={handleSpeedChange} className=" font-bold py-2 px-4 rounded">
//         {speed}x
//       </button> */}
//        <button
//        style={{color:"#D9EE15"}}
//         onClick={() => setShowDropdown(!showDropdown)}
//         className="text-white text-sm font-bold py-2 px-4 rounded"
//       >
//         {speed}x
//       </button>
//       {showDropdown && (
//         <div
//           style={{ backgroundColor: "#d9ee1591", color: "white",padding:"5px",marginLeft:"-288px",marginBottom:"200px" }}
//           className="absolute mt-2 rounded shadow-lg"
//         >
//           {speedOptions.map((option) => (
//             <div key={option}>
//               <button
//                 onClick={() => handleSpeedChange(option)}
//                 className="block w-full text-left px-4 py-2"
//                 style={{
//                   // backgroundColor: "#d9ee1591",
//                   color: "#161414",
//                   width:"80px",
//                   display:"flex",
//                   justifyContent:"space-between",
//                   borderBottom: "1px solid #161414",
//                 }}
//               >
//                 <span>{option}x</span> <span className="text-xl font-bold">{option === speed && "✓"}</span>
//               </button>
//             </div>
//           ))}
//         </div>
//       )}
//       <button style={{color:"#D9EE15"}} onClick={() => handleSkip(-30)} className=" text-xl font-bold py-2 px-4 rounded">
//         <RiReplay30Fill/>
//       </button>
      
//       <button style={{color:"#D9EE15"}} onClick={() => handleSkip(30)} className=" text-xl font-bold py-2 px-4 rounded">
//         <RiForward30Line/>
//       </button>

//       <button style={{color:"#D9EE15"}} onClick={() => handleShare()} className=" text-xl font-bold py-2 px-4 rounded">
//         <IoShareSocialOutline/>
//       </button>
//     </div>
//     <hr className="My-audio-payer-hr" />

//     <div className="mb-4 my-range-input-of-audio-player">
//       <input
//         type="range"
//         min="0"
//         max="100"
//         value={(currentTime / duration) * 100 || 0}
//         onChange={handleSeek}
//         className="seek-bar w-full"
//         style={{ backgroundImage: `linear-gradient(#d9ee15,#d9ee15)`,
//           backgroundSize: `${(currentTime / duration) * 100}% 100%`,
//           backgroundRepeat: "no-repeat"}}
//     />
//       <div className="flex justify-between text-white text-sm mt-1" style={{width:"100%"}}>
//         <span style={{color:"#D9EE15"}}>{formatTime(currentTime)}</span>
//         <span style={{color:"#D9EE15"}}>{formatTime(duration)}</span>
//       </div>
//     </div>

    
//   </div>
//   );
// };

// export default AudioPlayer;